var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', [_vm._v(" " + _vm._s(_vm.$t("components.PartnerReportDetail.rental.PartnerReportSelectRentalCompanyCard.title")) + " "), _c('v-spacer'), _c('m-icon-button', {
    attrs: {
      "icon": _vm.selectIcon,
      "disabled": _vm.report.isRentalCompanyLoading || _vm.isUpdatingReport
    },
    on: {
      "click": _vm.openDialog
    }
  })], 1), _c('v-card-text', [!_vm.rentalCompanyId ? _c('m-no-content', {
    attrs: {
      "text": _vm.$t('components.PartnerReportDetail.rental.PartnerReportSelectRentalCompanyCard.noRentalText')
    }
  }) : _vm.report.isRentalCompanyLoading || _vm.isUpdatingReport ? _c('v-skeleton-loader', {
    staticClass: "mb-2",
    attrs: {
      "type": "image",
      "height": "124"
    }
  }) : _vm.report.rentalCompany ? _c('company-sheet', {
    attrs: {
      "company": _vm.report.rentalCompany
    }
  }) : _c('m-no-content', {
    attrs: {
      "text": _vm.$t('components.PartnerReportDetail.rental.PartnerReportSelectRentalCompanyCard.loadingError')
    }
  })], 1), _c('confirm-action-dialog', {
    attrs: {
      "title": _vm.$t("components.PartnerReportDetail.rental.PartnerReportSelectRentalCompanyCard.title"),
      "isDialogActive": _vm.selectDialog,
      "rightLoading": _vm.isUpdatingReport,
      "hideLeft": true
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.selectDialog = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.selectDialog = $event;
      },
      "rightClick": _vm.selectRental
    }
  }, [_c('company-selection', {
    attrs: {
      "filter": _vm.filter
    },
    model: {
      value: _vm.localRentalCompany,
      callback: function callback($$v) {
        _vm.localRentalCompany = $$v;
      },
      expression: "localRentalCompany"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }